// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["build/css/front/unocms-v4/main"], () => (__webpack_require__("./resources/assets/js/front/unocms-v4/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["build/css/front/unocms-v4/main"], () => (__webpack_require__("./resources/assets/sass/front/unocms-v4/main.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
